/** Marks controls that belong on screen but not on paper. */
export const PDF_HIDE_CLASS = 'gil-pdf-hide';

/** Marks the report itself, so printing leaves out the app header and sidebar. */
export const PRINT_ROOT_CLASS = 'gil-print-root';

/** Cards and tables that should not be split across two pages. */
export const PDF_BLOCK_CLASS = 'gil-pdf-block';

/**
 * Prints the report through the browser's own print dialog, which also covers
 * "Save as PDF" on systems where people prefer it.
 *
 * Everything outside the report is hidden for the print, so the app header,
 * sidebar and the on-screen controls stay off the page.
 */
export const printReport = () => {
  const style = document.createElement('style');
  style.media = 'print';
  style.textContent = `
    @page { size: A4 landscape; margin: 10mm; }
    body * { visibility: hidden; }
    .${PRINT_ROOT_CLASS}, .${PRINT_ROOT_CLASS} * { visibility: visible; }
    .${PRINT_ROOT_CLASS} {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      padding: 0 !important;
    }
    .${PDF_HIDE_CLASS} { display: none !important; }
    tr, img, .${PDF_BLOCK_CLASS} {
      break-inside: avoid;
      page-break-inside: avoid;
    }
  `;
  document.head.appendChild(style);

  const cleanUp = () => {
    style.remove();
    window.removeEventListener('afterprint', cleanUp);
  };
  window.addEventListener('afterprint', cleanUp);

  window.print();
  //~ Safari fires no afterprint in some versions; drop the rules regardless.
  window.setTimeout(cleanUp, 1000);
};
